
define("bundles/magento-ui", function(){});
